/**
 * Zeus category grid — mobile rail scroll indicators.
 */
(function () {
  "use strict";

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isMobileRail() {
    return window.matchMedia("(max-width: 699px)").matches;
  }

  function isStackedMobile(rail) {
    return rail.classList.contains("zeus-cg__grid--stack-mobile") && window.matchMedia("(max-width: 479px)").matches;
  }

  function activateIndicator(indicators, idx) {
    indicators.forEach(function (indicator) {
      var indicatorIdx = parseInt(indicator.getAttribute("data-index"), 10);
      var isActive = indicatorIdx === idx;
      indicator.classList.toggle("is-active", isActive);
      if (isActive) {
        indicator.setAttribute("aria-current", "true");
      } else {
        indicator.removeAttribute("aria-current");
      }
    });
  }

  function initMobileRail(root) {
    if (!isMobileRail()) {
      return;
    }

    var rail = root.querySelector(".zeus-cg__grid");
    var cards = root.querySelectorAll("[data-cg-card]");
    var indicators = root.querySelectorAll("[data-cg-indicator]");

    if (!rail || cards.length <= 1 || !indicators.length || isStackedMobile(rail)) {
      return;
    }

    var scrollBehavior = prefersReducedMotion() ? "auto" : "smooth";

    indicators.forEach(function (indicator) {
      indicator.addEventListener("click", function () {
        var idx = parseInt(indicator.getAttribute("data-index"), 10);
        if (Number.isNaN(idx)) {
          return;
        }

        var target = null;
        cards.forEach(function (card) {
          if (parseInt(card.getAttribute("data-index"), 10) === idx) {
            target = card;
          }
        });

        if (!target) {
          return;
        }

        target.scrollIntoView({
          behavior: scrollBehavior,
          inline: "start",
          block: "nearest",
        });
        activateIndicator(indicators, idx);
      });
    });

    if (typeof IntersectionObserver === "undefined") {
      return;
    }

    var visibleRatios = new Map();

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visibleRatios.set(entry.target, entry.intersectionRatio);
          } else {
            visibleRatios.delete(entry.target);
          }
        });

        var bestTarget = null;
        var bestRatio = -1;

        visibleRatios.forEach(function (ratio, target) {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestTarget = target;
          }
        });

        if (bestTarget && bestRatio >= 0) {
          var activeIdx = parseInt(bestTarget.getAttribute("data-index"), 10);
          if (!Number.isNaN(activeIdx)) {
            activateIndicator(indicators, activeIdx);
          }
        }
      },
      {
        root: rail,
        threshold: [0.35, 0.55, 0.75],
      },
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initCategoryGrid(root) {
    initMobileRail(root);
  }

  function boot() {
    document.querySelectorAll("[data-zeus-category-grid]").forEach(initCategoryGrid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section) {
      return;
    }
    var root = section.querySelector("[data-zeus-category-grid]");
    if (root) {
      initCategoryGrid(root);
    }
  });
})();
